import { Subnav } from '@monorepo/shared/componentsV2/Subnav';
import React from 'react';

const subnavOptions = [
  {
    href: 'logs',
    label: 'Logs',
  },
  {
    href: 'resource-types',
    label: 'Resources',
  },
  {
    href: 'workflows',
    label: 'Workflows',
  },
];

export function DataSetupSubnav() {
  return <Subnav label="Data Setup" options={subnavOptions} />;
}
